module.exports = __webpack_public_path__ + "media/images/twitter-f87875828fb9d12208a18d758b1cbb30.svg";